<template>
  <div class="search-box-dropdown" style="width: 100%">
    <md-field
      class="md-search-box input-dropdown"
      style="margin-left: 0px"
      v-click-outside="clickOutSideInput"
    >
      <i
        v-if="typeSearch === true"
        class="md-icon material-icons show-icon"
        style="color: #a8a8a8; margin-top: 6px; cursor: pointer"
        :title="titleSearch"
        @click="selectSearch"
        >find_replace</i
      >
      <i
        v-else
        class="md-icon material-icons show-icon"
        style="color: #a8a8a8; margin-top: 6px"
        >add</i
      >
      <md-input
        type="text"
        :placeholder="placeholderSearch"
        v-model="valueSearchInput"
        v-on:keyup.enter="onSearchValue"
        @focus.native="focusInput"
        :ref="`add_product_input`"
      ></md-input>
      <i
        class="material-icons input-dropdown-close"
        style="display: none"
        title="Clear"
        @click="clearValueInput('true')"
        >cancel</i
      >
    </md-field>
    <!-- <label style="display: none">{{ focusInputProduct }}</label> -->

    <div
      class="div-dropdown"
      v-show="haveValue"
      v-click-outside="clickOutSideDivList"
    >
      <div
        style="position: absolute; top: 160%; left: 42%; z-index: 3"
        v-show="loading == true"
      >
        <md-progress-spinner
          :md-stroke="3"
          :md-diameter="35"
          md-mode="indeterminate"
        ></md-progress-spinner>
      </div>

      <md-list>
        <md-list-item v-show="dataList.length === 0 && !loading" class="no-data"
          >No data found.</md-list-item
        >
        <template v-if="dataList.length > 0">
          <md-list-item
            v-for="(item, dIndex) in dataList"
            :key="dIndex"
            :title="item.label"
            @click="selectChecked(item)"
          >
            <div style="display: table; width: 100%; height: 25px">
              <span class="-label"> {{ item.id }} - {{ item.label }} </span>
            </div>
          </md-list-item>
        </template>
      </md-list>
    </div>

    <md-snackbar
      :md-position="position"
      :md-duration="isInfinity ? Infinity : duration"
      :md-active.sync="showSnackbar"
      md-persistent
    >
      <span>{{ contentSnackbar }}</span>
      <md-button class="md-primary" @click="showSnackbar = false">OK</md-button>
    </md-snackbar>
  </div>
</template>

<script>
import promotionService from "@/services/promotion";
import PricingService from "@/services/pricing";

export default {
  name: "search-box-dropdown",

  props: {
    typeSearch: {
      type: Boolean,
      required: false,
    },
    menuSelected: {
      type: String,
      required: false,
      default: "Promotion",
    },
    valueInput: {
      type: Object,
      required: false,
    },
  },

  mounted() {
    // this.$nextTick(() => {
    // console.log("this.valueInput ==>", this.valueInput);
    this.valueSearchInput =
      this.valueInput === undefined || this.valueInput.id === undefined
        ? ""
        : this.valueInput.id + " - " + this.valueInput.label;
    // });
  },

  watch: {
    menuSelected() {
      this.clearValueInput("true");
    },
  },

  data() {
    return {
      valueSearchInput: "",
      dataList: [],
      haveValue: false,
      loading: false,
      showSnackbar: false,
      contentSnackbar: "",
      position: "center",
      duration: 4000,
      isInfinity: false,
      checkSearch: 0,
      placeholderSearch: "Search Product Code...",
      titleSearch: "Click to change search by item code",
      clearInputValue: true,
    };
  },

  methods: {
    selectSearch() {
      this.checkSearch++;
      if (this.checkSearch == 1) {
        this.placeholderSearch = "Search Product Name...";
        this.titleSearch = "Click to change search by item code";
      } else {
        this.placeholderSearch = "Search Product Code...";
        this.titleSearch = "Click to change search by item name";
        this.checkSearch = 0;
      }

      this.dataList = [];
      this.valueSearchInput = "";
      this.haveValue = false;
      if (this.menuSelected === "manage") {
        this.$emit("addproduct", "");
      }
    },
    focusInput() {
      this.$emit("focus");
    },
    getAllProductPromotion() {
      let datas = {
        filter: this.valueSearchInput,
        searchby: this.checkSearch === 0 ? "code" : "name",
      };
      promotionService
        .getAllProductGroup(datas)
        .then((response) => {
          if (response) {
            this.dataList = response;
            this.loading = false;
            // response.sort((a, b) => (a.id > b.id ? 1 : -1));
            // this.dataProductGroups = response;
            // this.productGroups = response;
          }
        })
        .catch();
    },
    getAllProductVD() {
      let emp_code = this.$jwt.decode(localStorage.getItem("token")).code;
      let datas = {
        pro_code: "",
        type: "master",
        data_delete: [],
        emp_code: emp_code,
        name: "",
        group: "",
        subgroup: "",
        cg: "",
        filter: this.valueSearchInput,
        searchby: this.checkSearch === 0 ? "code" : "name",
      };

      PricingService.getAllProductGroup(datas)
        .then((response) => {
          if (response.data) {
            this.dataList = response.data;
            this.loading = false;
            // response.data.sort((a, b) => (a.id > b.id ? 1 : -1));
            // this.dataProductGroupsVD = response.data;
          }
        })
        .catch();
    },
    getAllProductGroup() {
      let datas = {
        filter: this.valueSearchInput,
        searchby: this.checkSearch === 0 ? "code" : "name",
      };
      promotionService
        .getProductGroups(datas)
        .then((response) => {
          if (response) {
            this.dataList = response;
            this.loading = false;
            // response.sort((a, b) => (a.id > b.id ? 1 : -1));
            // this.dataProductGroups = response;
            // this.productGroups = response;
          }
        })
        .catch();
    },
    onSearchValue() {
      if (this.valueSearchInput.trim().length < 3) {
        this.showSnackbar = true;
        this.contentSnackbar = "Please fill in at least 3 characters";
      } else {
        this.showSnackbar = false;

        this.loading = true;
        this.haveValue = true;
        this.dataList = [];

        if (this.menuSelected === "Promotion") {
          this.clearInputValue = true;
          this.getAllProductPromotion();
        } else if (this.menuSelected === "Volume Discount") {
          this.clearInputValue = true;
          this.getAllProductVD();
        } else {
          this.clearInputValue = false;
          this.getAllProductGroup();
        }
      }
    },
    selectChecked(item) {
      this.haveValue = false;
      this.valueSearchInput = item.id + " - " + item.label;
      this.$emit("addproduct", item);
    },
    clearValueInput(clear) {
      if (this.clearInputValue === true || clear === "true") {
        // if (this.valueInput.id === undefined) {
        this.valueSearchInput = "";
        // }
        if (this.menuSelected === "manage" && clear === "true") {
          this.$emit("addproduct", "");
        }
      }
      this.dataList = [];
      this.haveValue = false;
    },
    clickOutSideInput() {
      if (
        (!this.haveValue && this.valueSearchInput === "") ||
        this.menuSelected === "Promotion" ||
        this.menuSelected === "Volume Discount"
      ) {
        this.clearValueInput();
      }
    },
    clickOutSideDivList() {
      if (this.haveValue) {
        if (this.clearInputValue === true) {
          this.valueSearchInput = "";
        }
        this.dataList = [];
        this.haveValue = false;
      }
    },
    onClickConfirmDialogAlert() {
      this.showSnackbar = false;
    },
  },
};
</script>

<style lang="scss">
.search-box-dropdown {
  position: relative;
  width: 100% !important;
  min-height: 36px !important;

  &.higher {
    .input-dropdown {
      // margin-bottom: 0px !important;

      &.md-focused,
      &.md-has-value {
        margin-top: 2px !important;

        .md-input {
          margin-top: 12px;
        }

        .input-dropdown-close {
          margin-top: 14px;
          margin-bottom: 0px;
        }
      }
    }
  }

  .input-dropdown:after {
    background-color: #414141 !important;
  }

  .-required.input-dropdown:after {
    background-color: #3f51b5 !important;
  }

  .input-dropdown {
    margin-top: 14px !important;
    margin-bottom: 0px !important;

    &.md-focused,
    &.md-has-value {
      // margin-top: 2px !important;

      .md-input {
        // margin-top: 12px;
        font-size: 14px !important;
        font-family: Roboto;
        padding-right: 5px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .input-dropdown-close {
        display: block !important;
        // margin-top: 14px;
        // margin-bottom: 0px;
        font-size: 24px !important;
        color: #a8a8a8;
        cursor: pointer;
      }
    }

    &.md-focused {
      .input-dropdown-close {
        color: #3f51b5;
      }
    }

    label {
      color: #727272;
      font-size: 12px !important;
      font-family: Roboto;
    }
  }

  .div-dropdown {
    .md-list-item {
      &.no-data {
        .md-list-item-content {
          text-align: center;
        }
      }

      .md-list-item-content {
        padding: 6px 12px;
      }
    }

    .md-list {
      width: 100%;
      max-width: 100%;
      display: inline-block;
      vertical-align: top;
      border: 1px solid rgba(#000, 0.12);
      position: absolute;
      padding: 5px 0;
      z-index: 2;
      overflow-y: scroll;
      height: 180px;

      .md-list-item-container {
        font-size: 14px !important;
        font-family: Kanit;

        .md-list-item-content {
          min-height: 35px;
          color: #5a5a5a;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          display: block;
          width: inherit;
        }
      }

      :hover {
        background: rgba(236, 236, 235, 1);
        color: #5a5a5a;
      }

      &::-webkit-scrollbar {
        height: 7px;
        width: 6px;
        background: #f7f7f7;
      }

      &::-webkit-scrollbar-thumb {
        background-color: rgba(0, 0, 0, 0.11);
        border-radius: 5px;
      }
    }
  }

  .md-field.md-theme-default:before {
    background-color: unset;
  }

  .md-search-box {
    margin-bottom: 0px !important;
    box-shadow: 0px 0px 2px #ababab;

    &.input-dropdown {
      margin-top: 7px !important;

      &.md-has-value,
      &.md-focused {
        .input-dropdown-close {
          font-size: 21px !important;
          padding: 8px;
        }
      }

      &.md-focused label {
        color: #3f51b5 !important;
      }

      &.md-focused .md-icon {
        color: #3f51b5 !important;
      }

      label {
        font-size: 11px !important;
      }
    }

    input::-webkit-input-placeholder {
      font-size: 14px !important;
      font-family: Roboto;
    }
  }
  .input-dropdown:after {
    background-color: #0000001f !important;
  }

  .div-dropdown {
    .md-list {
      height: 220px;
    }

    .md-list-item {
      &.no-data {
        .md-list-item-content {
          text-align: center;
        }
      }

      .md-list-item-content {
        padding: 2px 8px;

        .-label {
          width: 90%;
          //   display: block;
          display: table-cell;
          vertical-align: middle;
          margin: auto;
          padding-top: 3px;
          padding-left: 3px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          cursor: pointer;
        }
      }
    }
  }
}
</style>